export const CSS_VAR_SHOPPING_CART_WIDTH_FOR_LARGE_SCREEN = "--shopping-journeys-width-large-screen";